import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
import { Unprotect } from "../../../routes/cryptography";
import FileDownload from "js-file-download";
import { Buffer } from "buffer"

//const feedback = "Ты сделал это!";

class UnprotectView extends Component {
  constructor() {
    super();
    this.state = {
      dataUnprotect: {
        data: "",
        alg: "belt-ctr256",
        dataPrivKey: "",
        password: "",
        dataPubKey: "",
        datasign: "",
        token: "",
      },
      pubkeyFileName: "файл",
      pubkeyFileIsOpen: false,

      dataPubKeyFileName: "файл",
      dataPubKeyFileIsOpen: false,

      signFileName: "файл",
      signFileIsOpen: false,

      tokenFileName: "файл",
      tokenFileIsOpen: false,

      privkeyFileName: "файл",
      privkeyFileIsOpen: false,

      isValidFileSize: true,
      isValidPubKeyFileSize: true,
      isValidSignFileSize: true,
      isValidTokenFileSize: true,
      isValidPrivKeyFileSize: true,


      errors: {},
    };

    // this.handleInputChangedataUnprotect = this.handleInputChangedataUnprotect.bind(
    //   this
    // );
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.handleFileForEncryptChange = this.handleFileForEncryptChange.bind(
      this
    );
    this.handlePubKeyChange = this.handlePubKeyChange.bind(this);

    this.handleInputPassChange = this.handleInputPassChange.bind(this);
    this.handlePrivKeyChange = this.handlePrivKeyChange.bind(this);
    this.handleSignChange = this.handleSignChange.bind(this);
    this.handleTokenChange = this.handleTokenChange.bind(this);

    this.handleEncryptSubmit = this.handleEncryptSubmit.bind(this);
  }

  componentDidMount() { }
  handleSelectChange(e) {
    try {
      //console.log(e.target.value);
      this.setState({
        dataUnprotect: { ...this.state.dataUnprotect, alg: e.target.value },
      });
    } catch (error) {
      //console.log(error);
    }
  }

  handleInputPassChange(e) {
    //console.log(e.target.value);
    try {
      this.setState({
        dataUnprotect: {
          ...this.state.dataUnprotect,
          password: e.target.value,
        },
      });

      ////console.log(e.target.value);
    } catch (error) {
      //console.log(error);
    }
  }
  //   handleInputChangedataUnprotect(e) {
  //     console.log(e.target.value);
  //     try {
  //       this.setState({
  //         dataPubKeyFileName: "файл",
  //         dataPubKeyFileIsOpen: false,
  //         signFileName: "файл",
  //         signFileIsOpen: false,
  //         certFileName: "файл",
  //         certFileIsOpen: false,

  //         dataUnprotect: {
  //           ...this.state.dataUnprotect,
  //           data: btoa(unescape(encodeURIComponent(e.target.value))),
  //         },
  //       });
  //       console.log(e.target.value.length);

  //       console.log(e.target.value);
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   }

  handleFileForEncryptChange() {
    try {
      const file = document.getElementById("dataForEncrypt").files[0];
      console.log(file);

      if (file !== undefined && file.size < 20000000) {
        this.setState({
          dataPubKeyFileName: file.name,
          dataPubKeyFileIsOpen: true,
          isValidFileSize: true,

        });
        var reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = () => {
          const buffer = reader.result;

          const data = new Buffer(new Uint8Array(buffer)).toString();

          this.setState({
            dataUnprotect: { ...this.state.dataUnprotect, data: data },
          });
          //console.log(data);
        };
        reader.onerror = (e) => {
          console.error(e);
        };
      } else {
        this.setState({
          dataPubKeyFileName: "файл",
          dataPubKeyFileIsOpen: false,
          isValidFileSize: false,

        });
      }
    } catch (error) {
      //console.log(error);
    }
  }

  handlePubKeyChange() {
    try {
      const file = document.getElementById("filePubkey").files[0];
      //console.log(file);

      if (file !== undefined && file.size < 20000000) {
        this.setState({ pubkeyFileName: file.name, pubkeyFileIsOpen: true, isValidPubKeyFileSize: true, });
        var reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = () => {
          const buffer = reader.result;

          const data = new Buffer(new Uint8Array(buffer)).toString("base64");

          this.setState({
            dataUnprotect: { ...this.state.dataUnprotect, dataPubKey: data },
          });
          //console.log(data);
        };
        reader.onerror = (e) => {
          console.error(e);
        };
      } else {
        this.setState({ pubkeyFileName: "файл", pubkeyFileIsOpen: false.valueOf, isValidPubKeyFileSize: false, });
      }
    } catch (error) {
      //console.log(error);
    }
  }

  handlePrivKeyChange() {
    try {
      const file = document.getElementById("filePrivkey").files[0];
      //console.log(file);

      if (file !== undefined && file.size < 20000000) {
        this.setState({
          privkeyFileName: file.name, privkeyFileIsOpen: true, isValidPrivKeyFileSize: true,
        });
        var reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = () => {
          const buffer = reader.result;

          const data = new Buffer(new Uint8Array(buffer)).toString("base64");

          this.setState({
            dataUnprotect: { ...this.state.dataUnprotect, dataPrivKey: data },
          });
          //console.log(data);
        };
        reader.onerror = (e) => {
          console.error(e);
        };
      } else {
        this.setState({
          privkeyFileName: "файл", privkeyFileIsOpen: false, isValidPrivKeyFileSize: false,
        });
      }
    } catch (error) {
      //console.log(error);
    }
  }

  handleSignChange() {
    try {
      const file = document.getElementById("fileSign").files[0];
      //console.log(file);

      if (file !== undefined && file.size < 20000000) {
        this.setState({ signFileName: file.name, signFileIsOpen: true, isValidSignFileSize: true });
        var reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = () => {
          const buffer = reader.result;

          const data = new Buffer(new Uint8Array(buffer)).toString();

          this.setState({
            dataUnprotect: { ...this.state.dataUnprotect, datasign: data },
          });
          //console.log(data);
        };
        reader.onerror = (e) => {
          console.error(e);
        };
      } else {
        this.setState({ signFileName: "файл", signFileIsOpen: false, isValidSignFileSize: false });
      }
    } catch (error) {
      //console.log(error);
    }
  }

  handleTokenChange() {
    try {
      const file = document.getElementById("fileToken").files[0];
      //console.log(file);

      if (file !== undefined && file.size < 20000000) {
        this.setState({ tokenFileName: file.name, tokenFileIsOpen: true, isValidTokenFileSize: true, });
        var reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = () => {
          const buffer = reader.result;

          const data = new Buffer(new Uint8Array(buffer)).toString();

          this.setState({
            dataUnprotect: { ...this.state.dataUnprotect, token: data },
          });
          //console.log(data);
        };
        reader.onerror = (e) => {
          console.error(e);
        };
      } else {
        this.setState({ tokenFileName: "файл", tokenFileIsOpen: false, isValidTokenFileSize: false });
      }
    } catch (error) {
      //console.log(error);
    }
  }

  handleEncryptSubmit(e) {
    e.preventDefault();
    try {
      //console.log(`Данные: ${this.state.dataUnprotect.data}`);
      //console.log(`алгоритм: ${this.state.dataUnprotect.alg}`);
      //console.log(`ключ: ${this.state.dataUnprotect.dataPubKey}`);
      Unprotect(
        btoa(unescape(encodeURIComponent(this.state.dataUnprotect.alg))),
        this.state.dataUnprotect.data,
        this.state.dataUnprotect.dataPrivKey,
        btoa(unescape(encodeURIComponent(this.state.dataUnprotect.password))),
        this.state.dataUnprotect.dataPubKey,
        this.state.dataUnprotect.token,
        this.state.dataUnprotect.datasign
      ).then((res) => {

        if (res.status === 200) {
          FileDownload(
            new Buffer.from(res.data.dataUnprotect, "base64").toString(),
            "decryptData.txt"
          );

          document.getElementById("view").style.borderColor = "green";
        } else {
          document.getElementById("view").style.borderColor = "red";
        }
      });
    } catch (error) {
      document.getElementById("view").style.borderColor = "red";

      console.log(error);
    }
  }

  render() {
    return (
      <div className="container" >
        <h6 className="major">{this.props.encryptType}</h6>
        <Form onSubmit={this.handleEncryptSubmit}>
          <div className="sm-4">
            {/* <Form.Group>
              <Form.Label>Введите текст</Form.Label>
              <Form.Control
                id="inputdataUnprotect"
                onChange={this.handleInputChangedataUnprotect}
                as="textarea"
                aria-label="With textarea"
              />
            </Form.Group> */}

            <Form.Group>
              <Form.Label>Выберите файл для расшифровки </Form.Label>
              <Form.File custom>
                <Form.File.Input
                  id="dataForEncrypt"
                  onChange={this.handleFileForEncryptChange}
                  isValid={this.state.dataPubKeyFileIsOpen}
                  isInvalid={!this.state.isValidFileSize}

                />
                <Form.File.Label data-browse="Выбрать">
                  {this.state.dataPubKeyFileName}
                </Form.File.Label>
                <Form.Control.Feedback type="valid" />
                <Form.Control.Feedback type="invalid">
                  максимальный размер файла 20мб
                </Form.Control.Feedback>
              </Form.File>
            </Form.Group>
            <Form.Group>
              <Form.Label>Алгоритм шифрования</Form.Label>
              <Form.Control
                onChange={this.handleSelectChange}
                defaultValue={this.state.dataUnprotect.alg}
                as="select"
                custom
              >
                <option>belt-ctr256</option>
                <option>belt-ecb256</option>
                <option>belt-cbc256</option>
                <option>belt-cfb256</option>
              </Form.Control>
            </Form.Group>

            <Form.Group>
              <Form.Label>Выберите файл личного ключа</Form.Label>
              <Form.File custom>
                <Form.File.Input
                  id="filePrivkey"
                  onChange={this.handlePrivKeyChange}
                  isValid={this.state.privkeyFileIsOpen}
                  isInvalid={!this.state.isValidPrivKeyFileSize}

                  required
                />
                <Form.File.Label data-browse="Выбрать">
                  {this.state.privkeyFileName}
                </Form.File.Label>
                <Form.Control.Feedback type="valid" />
                <Form.Control.Feedback type="invalid">
                  максимальный размер файла 20мб
                </Form.Control.Feedback>
              </Form.File>
            </Form.Group>

            <Form.Group>
              <Form.Label>Введите пароль личного ключа</Form.Label>
              <Form.Control
                type="password"
                placeholder="Пароль"
                onChange={this.handleInputPassChange}
                style={{ height: "2rem", color: 'white' }}
                required
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>
                Выберите файл открытого ключа или сертификат получателя
              </Form.Label>
              <Form.File custom>
                <Form.File.Input
                  id="filePubkey"
                  onChange={this.handlePubKeyChange}
                  isValid={this.state.pubkeyFileIsOpen}
                  isInvalid={!this.state.isValidPubKeyFileSize}

                  required
                />
                <Form.File.Label data-browse="Выбрать">
                  {this.state.pubkeyFileName}
                </Form.File.Label>
                <Form.Control.Feedback type="valid" />
                <Form.Control.Feedback type="invalid">
                  максимальный размер файла 20мб
                </Form.Control.Feedback>
              </Form.File>
            </Form.Group>

            <Form.Group>
              <Form.Label>Выберите токен</Form.Label>
              <Form.File custom>
                <Form.File.Input
                  id="fileToken"
                  onChange={this.handleTokenChange}
                  isValid={this.state.tokenFileIsOpen}
                  isInvalid={!this.state.isValidTokenFileSize}

                  required
                />
                <Form.File.Label data-browse="Выбрать">
                  {this.state.tokenFileName}
                </Form.File.Label>
                <Form.Control.Feedback type="valid" />
                <Form.Control.Feedback type="invalid">
                  максимальный размер файла 20мб
                </Form.Control.Feedback>
                
              </Form.File>
            </Form.Group>

            <Form.Group>
              <Form.Label>Выберите файл подписи</Form.Label>
              <Form.File custom>
                <Form.File.Input
                  id="fileSign"
                  onChange={this.handleSignChange}
                  isValid={this.state.signFileIsOpen}
                  isInvalid={!this.state.isValidSignFileSize}
                  required
                  style={{ color: 'white' }}
                />
                <Form.File.Label data-browse="Выбрать">
                  {this.state.signFileName}
                </Form.File.Label>
                <Form.Control.Feedback type="valid" />
                <Form.Control.Feedback type="invalid">
                  максимальный размер файла 20мб
                </Form.Control.Feedback>
              </Form.File>
            </Form.Group>

            {/* <Form.Label style={{ float: "left" }}>
              {this.state.dataSign.statusSign}
            </Form.Label> */}
            <Button
              style={{ float: "right" }}
              type="submit"
              size="sm"
            >
              Расшифровать
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}
export default connect()(withRouter(UnprotectView));
